import { IApiInformation } from '@models/index';
import { API_INFORMATION_LOADED } from './apiInformation.constants';
import { DispatchEvent, StoreNative } from '../Store';

export function apiInformationReducer(
    state: StoreNative<IApiInformation> = new StoreNative<IApiInformation>(),
    action: DispatchEvent<IApiInformation>
) {
    let newState = state;
    if (action && action.type) {
        switch (action.type) {
            case API_INFORMATION_LOADED:
                newState = {
                    hasError: false,
                    isLoaded: true,
                    isLoading: true,
                    value: action.payload
                };
                break;
        }
    }
    return newState;
}